import axios from "axios";
import { useEffect, useState } from "react";
import params from "../params";

function Level(props) {
    return (
        <li>
            
        </li>
    );
}

export default function Roulette() {
    const [levels, setLevels] = useState([]);
    const [currLevels, setCurrLevels] = useState([]);
    const [start, setStart] = useState(
        <div>
            <h2>Рулетка случайнных уровней</h2>
            <p>Попытайте свою удачу, попробовав пройти рулетку до конца. Ваша задача — установить 100 рекордов, по одному на каждом уровне, увеличивая необходимый процент на единицу с каждым уровнем. Здесь могут встречаться как очень лёгкие уровни, так и демоны с лидирующих строк демонлиста. Желаем удачи!</p>
            <button className="start-roulette-btn" onClick={startRoulette}>Начать попытку</button>
        </div>
    );

    const startRoulette = () => {
        if(!levels) return;
        // addLevel();
        delete(document.querySelector('.start-roulette'));
    }

    const addLevel = () => {
        
    }
    
    useEffect(() => {
        const req = async () => {
            try {
                const r = await axios.get(params.apiUrl + '/demonlist/getRoulette.php');
                const lines = r.data.split('\n');
                const lvls = [];

                for(let i = 0; i < lines.length; i++) {
                    const params = lines[i].split(';');
                    lvls.push({ name: params[0], author: params[1], id: params[2] });
                }

                setLevels(lvls);
            } catch(e) {
                throw new Error(e.message);
            }
        }

        req();
    }, []);
    
    return (
        <main>
            <div className="container">
                <ul className="roulette-list">
                    <li className="start-roulette">
                        {start}
                    </li>
                    <Level />
                </ul>
            </div>
        </main>
    );
}